module.exports={
  "pending": "Pending",
  "contract-sent": "Contract Sent",
  "deposit-received": "Deposit Received",
  "balance-received": "Balance Received",
  "paid-out": "Paid Out",
  "no-show": "No Show"
}
